import { StateProvider } from '@uirouter/angularjs';
import { IMailboxPageData } from './shared/mailbox-page-data.interface';

export function mailboxRoutesConfig( $stateProvider: StateProvider ) {

  const mailboxStateName = 'app.dashboard.mailbox';

  $stateProvider
    .state(mailboxStateName, {
      url: '/mailbox',
      redirectTo: 'app.dashboard.mailbox.all'
    })
    .state(`${mailboxStateName}.all`, {
      url: '/',
      component: 'mailboxPage',
      data: {},
      resolve: {
        $title: () => 'Mailbox (All)'
      }
    })
    .state(`${mailboxStateName}.admin`, {
      url: '/admin',
      component: 'mailboxPage',
      data: {
        filter: 'admin'
      } as IMailboxPageData,
      resolve: {
        $title: () => 'Mailbox (from Admin)'
      }
    })
    .state(`${mailboxStateName}.business`, {
      url: '/business',
      component: 'mailboxPage',
      data: {
        filter: 'business'
      } as IMailboxPageData,
      resolve: {
        $title: () => 'Mailbox (from Business)'
      }
    })
    .state(`${mailboxStateName}.finance`, {
      url: '/finance',
      component: 'mailboxPage',
      data: {
        filter: 'finance'
      } as IMailboxPageData,
      resolve: {
        $title: () => 'Mailbox (from Finance)'
      }
    })
    .state(`${mailboxStateName}.imp-admin`, {
      url: '/important-admin',
      component: 'mailboxPage',
      data: {
        filter: 'admin',
        important: true
      } as IMailboxPageData,
      resolve: {
        $title: () => 'Mailbox (Important from Admin)'
      }
    })
    .state(`${mailboxStateName}.imp-business`, {
      url: '/important-business',
      component: 'mailboxPage',
      data: {
        filter: 'business',
        important: true
      } as IMailboxPageData,
      resolve: {
        $title: () => 'Mailbox (Important from Business)'
      }
    })
    .state(`${mailboxStateName}.imp-finance`, {
      url: '/important-finance',
      component: 'mailboxPage',
      data: {
        filter: 'finance',
        important: true
      } as IMailboxPageData,
      resolve: {
        $title: () => 'Mailbox (Important from Finance)'
      }
    });
}

mailboxRoutesConfig.$inject = [
  '$stateProvider'
];



// WEBPACK FOOTER //
// ./app/states/mailbox/mailbox-routing.ts